import React from 'react';
import {
  EnhancedLiveClassOffering,
  LiveClassTableStatus,
} from 'types/liveClass';
import { ScheduleCellProps } from './types';

const SeatsAvailableCell: React.FC<
  ScheduleCellProps & {
    getOfferingStatus?: (
      offering: EnhancedLiveClassOffering,
    ) => LiveClassTableStatus | null;
  }
> = ({ row, getOfferingStatus }) => {
  const offering = row?.original;
  const seatsAvailable = offering?.lms_seats_available;
  const maxEnrollments = offering?.lms_max_enrollments;

  if (seatsAvailable == null || maxEnrollments == null) {
    return null;
  }

  const status = getOfferingStatus?.(offering);
  const useActiveStyle =
    status === LiveClassTableStatus.Available ||
    status === LiveClassTableStatus.Scheduled;
  const variantClass = useActiveStyle
    ? 'live-class-seats-available--active'
    : 'live-class-seats-available--muted';

  return (
    <span className={`live-class-seats-available ${variantClass}`}>
      <span className="live-class-seats-available__count">
        {seatsAvailable}
      </span>
      <span className="live-class-seats-available__capacity">
        /{maxEnrollments}
      </span>
    </span>
  );
};

export default SeatsAvailableCell;
